import { SVGProps } from "react";

const ActivateIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="icono-activar"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.00002 11.5999C9.09282 11.5999 11.6 9.0927 11.6 5.9999C11.6 2.90711 9.09282 0.399902 6.00002 0.399902C2.90723 0.399902 0.400024 2.90711 0.400024 5.9999C0.400024 9.0927 2.90723 11.5999 6.00002 11.5999ZM6.70002 3.8999C6.70002 3.5133 6.38662 3.1999 6.00002 3.1999C5.61343 3.1999 5.30002 3.5133 5.30002 3.8999V5.2999H3.90002C3.51343 5.2999 3.20002 5.6133 3.20002 5.9999C3.20002 6.3865 3.51343 6.6999 3.90002 6.6999H5.30002V8.0999C5.30002 8.4865 5.61343 8.7999 6.00002 8.7999C6.38662 8.7999 6.70002 8.4865 6.70002 8.0999V6.6999H8.10003C8.48662 6.6999 8.80002 6.3865 8.80002 5.9999C8.80002 5.6133 8.48662 5.2999 8.10003 5.2999H6.70002V3.8999Z"
        fill="#6B7280"
      />
    </svg>
  );
};

export default ActivateIcon;
